import React, { useMemo, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/i-copa-faixa-solidaria-de-jiu-jitsu-2025/tabela-i-copa-faixa-solidaria-de-jiu-jitsu-2025.jpg";
import qrCodecopaAmizadeDeJiuJitsu2024 from "../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2024/qr-coce--copa-amizade-de-jiu-jitsu-2024.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import govAm from "../../assets/images/sponsors/logo-gov-am.png";
import deputadoMaciel from "../../assets/images/sponsors/cabo-maciel.png";



//Apoio
import trevusMartialArts from "../../assets/images/sponsors/trevus-martial-arts.jpg";
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";
import Papa from "papaparse";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";

const sponsors = [
 
  { img: govAm, url: "#" }, 
  { img: deputadoMaciel, url: "#" },
 
  
];


const support = [

  { img: torneio, url: "http://www.torneiofacil.com" },
];

const RESULTADO_CSV_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSCbMPeMqSiHgHD1ov3M85e3gJPsCN2BSpdsKEcR7Bt34Dz5Vh8HF6sNvQuyH5fzJDV09Q315v_fDgh/pub?gid=1385814576&single=true&output=csv";

const RESULTADO_INDIVIDUAL_CSV_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSCbMPeMqSiHgHD1ov3M85e3gJPsCN2BSpdsKEcR7Bt34Dz5Vh8HF6sNvQuyH5fzJDV09Q315v_fDgh/pub?gid=0&single=true&output=csv";


const cacheBuster = `?cacheBuster=${new Date().getTime()}`
const dataEvento = "20 de dezembro de 2025 "
const horaEvento = "9:00h da manhã"
const tituloEvento = "I Copa Faixa Solidária de Jiu Jitsu Gi"
const localEvento = "Arena Poliesportiva Amadeu Teixeira"
const endereçoEvento = "Av. Constantino Nery, s/n - Flores, Manaus - AM, CEP 69040-001"
const dataDeEncerramentoIncricao = "10/NOV/2025"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "10/NOV/2025"
const horaDeEncerramentoCorrecao = "22h:00min"

const dataDeEncerramentoInscricaoLoteUnico = ""
const dataDeEncerramentoInscricaoLote1 = "Completar 1.000 atletas inscritos"
const dataDeEncerramentoInscricaoLote2 = "30/SET/2025"
const dataDeEncerramentoInscricaoLote3 = "22/OUT/2025"


const valorinscricaoCategoriaAbsoluto = "30,00 (trinta reais)"
const valorinscricaoCategoriaAbsolutoLote3 = "40,00 (quarenta reais)"
const valorinscricaoCategoriaLote1 = "40,00 (quarenta reais)"
const valorinscricaoCategoriaLote2 = "50,00 (cinquenta reais)"
const valorinscricaoCategoriaLote3 = "70,00 (setenta reais)"

const valorinscricaoLoteUnicoComboGieNogi = "200,00 (duzentos reais)"
const valorinscricaoLote1ComboGieNogi = "200,00 (duzentos reais)"
const valorinscricaoLote2ComboGieAbsoluto = "70,00 (setenta reais)"
const valorinscricaoLote3ComboGieAbsoluto = "100,00 (cem reais)"

const valorinscricaoAbsolutoLoteUnico = "100,00 (cem reais)"
const valorinscricaoAbsolutoLote2 = "75,00 (setenta e cinco reais)"

const dataDeDivulgacaoChaves = "15/NOV/2025"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = "Bradesco"
const tipoDeChavePix = "Telefone"
const ChavePix = "(92) 99468-5161"
const BeneficiarioDaChavePix = "José Michel Tavares Pio"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "(92) 99247-0538"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi";
const slugNOGI = "i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-absoluto";
const rotaInscriçãoGi = `/enrollment/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi`;
const rotaChecagemGi = "/check/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi/search";
const rotaChecagemAbsoluto = "/check/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-absoluto/search";
const rotaChavesGI = "/tournament/keys/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi"
const rotaChavesAbsoluto = "/tournament/keys/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-absoluto"

const bannerImg = require("../../assets/images/tournaments/i-copa-faixa-solidaria-de-jiu-jitsu-2025/i-copa-faixa-solidaria-de-jiu-jitsu-2025.jpeg");


const ICopaFaixaSolidariaDeJiuJitsu2025: React.FC = () => {
  const { authenticated, getToken } = useAuthenticate();
  const navigate = useNavigate();

  const [resultadoModalOpen, setResultadoModalOpen] = useState(false);
  const [resultadoRows, setResultadoRows] = useState<any[]>([]);
  const [searchResultado, setSearchResultado] = useState("");

  const [resultadoIndModalOpen, setResultadoIndModalOpen] = useState(false);
  const [resultadoIndRows, setResultadoIndRows] = useState<any[]>([]);
  const [searchResultadoInd, setSearchResultadoInd] = useState("");

  const normalizeKey = (key: string) =>
    key
      .replace(/\s+/g, " ")
      .replace(/\n/g, " ")
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const getKeyNameByIncludes = (row: any, includes: string) => {
    const entry = Object.keys(row || {}).find((k) =>
      normalizeKey(k).includes(includes)
    );
    return entry || null;
  };

  const getValueByKeyIncludes = (row: any, includes: string) => {
    const key = getKeyNameByIncludes(row, includes);
    if (!key) return undefined;
    return row?.[key];
  };

  const parseNumberAny = (v: any) => {
    const s = String(v ?? "")
      .trim()
      .replace(/\./g, "")
      .replace(",", ".");
    const n = Number(s);
    return Number.isFinite(n) ? n : 0;
  };

  const parsePoints = (v: any) => {
    const s = String(v ?? "")
      .trim()
      .replace(/\./g, "")
      .replace(",", ".");
    const n = Number(s);
    return Number.isFinite(n) ? n : 0;
  };

  const loadResultadoAcademias = async () => {
    try {
      const res = await fetch(`${RESULTADO_CSV_URL}&t=${Date.now()}`);
      const csvText = await res.text();
      const parsed = Papa.parse(csvText, { header: true });

      const cleaned = (parsed.data as any[]).filter(
        (row) =>
          row &&
          Object.values(row).some((v) => String(v ?? "").trim() !== "")
      );

      setResultadoRows(cleaned);
    } catch {
      toast.error("Erro ao carregar resultado das academias");
    }
  };

  const loadResultadoIndividual = async () => {
    try {
      const res = await fetch(`${RESULTADO_INDIVIDUAL_CSV_URL}&t=${Date.now()}`);
      const csvText = await res.text();
      const parsed = Papa.parse(csvText, { header: true });

      const cleaned = (parsed.data as any[]).filter(
        (row) =>
          row &&
          Object.values(row).some((v) => String(v ?? "").trim() !== "")
      );

      setResultadoIndRows(cleaned);
    } catch {
      toast.error("Erro ao carregar resultados individuais");
    }
  };

  const filteredResultadoRows = useMemo(() => {
    const sorted = [...resultadoRows].sort((a, b) => {
      const pa = parsePoints(getValueByKeyIncludes(a, "ponto"));
      const pb = parsePoints(getValueByKeyIncludes(b, "ponto"));
      if (pb !== pa) return pb - pa;

      const aa = String(getValueByKeyIncludes(a, "academia") ?? "").trim();
      const ab = String(getValueByKeyIncludes(b, "academia") ?? "").trim();
      return aa.localeCompare(ab, "pt-BR", { sensitivity: "base" });
    });

    if (!searchResultado.trim()) return sorted;

    const q = searchResultado.toLowerCase();
    return sorted.filter((row) =>
      Object.entries(row || {})
        .map(([k, v]) => `${normalizeKey(k)} ${String(v ?? "").toLowerCase()}`)
        .join(" ")
        .includes(q)
    );
  }, [resultadoRows, searchResultado]);

  const processedIndividual = useMemo(() => {
    const rows = [...resultadoIndRows];

    const sample = rows[0] || {};
    const keyChave =
      getKeyNameByIncludes(sample, "chave") || getKeyNameByIncludes(sample, "key");
    const keyOrder =
      getKeyNameByIncludes(sample, "ordem") || getKeyNameByIncludes(sample, "order");
    const keyCategory =
      getKeyNameByIncludes(sample, "categoria") || getKeyNameByIncludes(sample, "category");
    const keyResultado =
      getKeyNameByIncludes(sample, "resultado") ||
      getKeyNameByIncludes(sample, "classific") ||
      getKeyNameByIncludes(sample, "coloc");
    const keyNome =
      getKeyNameByIncludes(sample, "nome") ||
      getKeyNameByIncludes(sample, "atleta") ||
      getKeyNameByIncludes(sample, "competidor");

    let filtered = rows;
    if (searchResultadoInd.trim()) {
      const q = searchResultadoInd.toLowerCase();
      filtered = rows.filter((row) =>
        Object.entries(row || {})
          .map(([k, v]) => `${normalizeKey(k)} ${String(v ?? "").toLowerCase()}`)
          .join(" ")
          .includes(q)
      );
    }

    const resultadoPriority = (val: any) => {
      const norm = normalizeKey(String(val ?? ""));
      if (norm === "1" || norm.includes("1 lugar")) return 1;
      if (norm === "2" || norm.includes("2 lugar")) return 2;
      if (norm === "3" || norm.includes("3 lugar")) return 3;
      if (norm.includes("wo")) return 4;
      if (norm.includes("desclass")) return 5;
      return 99;
    };

    const sorted = [...filtered].sort((a, b) => {
      const ca = parseNumberAny(keyChave ? a?.[keyChave] : undefined);
      const cb = parseNumberAny(keyChave ? b?.[keyChave] : undefined);
      if (ca !== cb) return ca - cb;

      const oa = parseNumberAny(keyOrder ? a?.[keyOrder] : undefined);
      const ob = parseNumberAny(keyOrder ? b?.[keyOrder] : undefined);
      if (oa !== ob) return oa - ob;

      if (keyResultado) {
        const pa = resultadoPriority(a?.[keyResultado]);
        const pb = resultadoPriority(b?.[keyResultado]);
        if (pa !== pb) return pa - pb;
      }

      if (keyNome) {
        const na = String(a?.[keyNome] ?? "").trim();
        const nb = String(b?.[keyNome] ?? "").trim();
        if (na !== nb) return na.localeCompare(nb, "pt-BR", { sensitivity: "base" });
      }

      return 0;
    });

    const out: any[] = [];
    let i = 0;

    const normVal = (v: any) => String(v ?? "").trim().toLowerCase();

    while (i < sorted.length) {
      const cur = sorted[i];
      const curOrder = normVal(keyOrder ? cur?.[keyOrder] : "");
      const curCat = normVal(keyCategory ? cur?.[keyCategory] : "");

      let span = 1;
      while (i + span < sorted.length) {
        const nxt = sorted[i + span];
        const nxtOrder = normVal(keyOrder ? nxt?.[keyOrder] : "");
        const nxtCat = normVal(keyCategory ? nxt?.[keyCategory] : "");

        if (nxtOrder === curOrder && nxtCat === curCat) span++;
        else break;
      }

      out.push({
        ...cur,
        __mergeFirst: true,
        __mergeSpan: span,
      });

      for (let k = 1; k < span; k++) {
        out.push({
          ...sorted[i + k],
          __mergeFirst: false,
          __mergeSpan: 0,
        });
      }

      i += span;
    }

    return {
      rows: out,
      keys: Object.keys(sample || {}),
      keyOrder,
      keyCategory,
    };
  }, [resultadoIndRows, searchResultadoInd]);

  const handleToSubscriptionPage = async () => {

    if (!authenticated) {
      Swal.fire({
        title: 'Você precisa estar autenticado',
        text: 'Deseja fazer login para se inscrever no evento?',
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Fazer login',
        focusConfirm: false,
        cancelButtonText: 'Agora não'
      }).then((action) => {
        if (action.isConfirmed) navigate('/login')
      });
      return;
    }

    const response = await api.get(
      `/tournaments/info/${slugGI}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    if (response.data.canSubscribe === false) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Período de inscrição encerrado!',
        icon: 'error',
      });
      toast.error('Período de inscrição encerrado!');
      return;
    }

    navigate(`/enrollment/${slugGI}`)

  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={bannerImg}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={bannerImg}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/sk5eDJ14rVzzZqhLA"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    A {tituloEvento} é um evento  que
                    fomenta e incentiva a prática do jiu jitsu no estado do Amazonas. As lutas
                    serão GI (com kimono), o evento disponibilizará
                    categorias para todas as idades e faixas, conforme a tabela de peso
                    deste edital. Os competidores terão a oportunidade de testar suas
                    habilidades em um ambiente controlado e com acompanhamento de
                    profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title="PREMIAÇÕES:  DINHEIRO💰 + TROFÉU🏆 + MEDALHAS🥇 " >

                  <H3>Academias:</H3>
                  <P>1° lugar: R$3.000,00 + 🏆 Troféu </P>
                  <P>2° lugar: R$2.000,00 + 🏆 Troféu </P>
                  <P>3° lugar: R$1.000,00 + 🏆 Troféu </P>


                  <br />
                  <H3>Absoluto Masculino GI:</H3>
                  <H5>Adulto/Master Azul - (Juntos) </H5>
                  <P>1° lugar: R$300,00 + Medalha🥇 </P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto/Master Roxa - (Juntos) </H5>
                  <P>1° lugar: R$400,00 + Medalha🥇 </P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto/Master Marrom -(Juntos) </H5>
                  <P>1° lugar: R$500,00 + Medalha🥇 </P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto/Master Preta - (Juntos)</H5>
                  <P>1° lugar: R$1.200,00 + Medalha🥇 </P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <br />

                  <H3>Absoluto Feminino GI:</H3>

                  <H5>Adulto/Master Azul - (Juntas) </H5>
                  <P>1° lugar: R$300,00 + Medalha🥇 </P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto/Master Roxa - (Juntas) </H5>
                  <P>1° lugar: R$400,00 + Medalha🥇 </P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto/Master Marrom -(Juntas) </H5>
                  <P>1° lugar: R$500,00 + Medalha🥇 </P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto/Master Preta - (Juntas)</H5>
                  <P>1° lugar: R$1.200,00 + Medalha🥇 </P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <br />
                  <H3>Demais Categorias GI</H3>
                  <P>1° lugar: medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <br />
                  <p>OBS: Estas premiações só irão valer para os Absolutos que tiverem mínimo de 06 (SEIS)
                    ou mais atletas inscritos para validação da premiação integral</p>
                  <p>Menos de 6 (SEIS) atletas inscritos no Absoluto, será concedido apenas 50% do valor da premiação.
                  </p>
                  <p>
                    Atleta sem luta não recebe dinheiro , somente cinturão.
                  </p>
                  <p>
                    Mais informações sobre as inscrições para o absoluto está disponível
                    na seção INSCRIÇÕES, parágrafo Inscrição de Absoluto deste edital.
                  </p>
                  <br />
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2025, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2025,
                    conforme regra da CBJJ.
                  </P>
                  <br />
                   <H3>Prazo de Inscrição</H3>
                   
                   <P>
                    Abertura das Inscrições será em 05/NOV/2025 às 18:00h.
                   </P>
                   
                  <P>
                    O prazo final para inscrições será até  {dataDeEncerramentoIncricao}, às {""}
                    {horaDeEncerramentoIncricao}min, ou até o torneio completar 1.000 inscrições.
                  </P>
                  <br /> 
                 {/*  <P>As inscrições que não forem pagas serão canceladas.</P> */}
                 
                 <H3>Valor  </H3>
                  <P>2kg de Alimentos não Perecíveis para confirmação da inscrição que será entregue no momento da pesagem do atleta.</P>
                  <P>
                  Caso o atleta se inscreva na categoria e absoluto , o mesmo deverá entregar 4kg de alimentos não perecíveis.
                  </P>
                 <P>
                  O Atleta só poderá lutar diante da confirmação de sua inscrição com sua entrega dos alimentos não perecíveis.
                 </P>
                  <br /> 

                  <H3>Correção</H3>
                 {/*  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P> */}
                 {/*  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P> */}
                   <P>
                    A correção da inscrição fica disponível após efetuar a inscrição.
                  </P>
               {/*    <P>
                  Atenção! A correção da inscrição ficará disponível até {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P> */}
                 {/*  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P> */}
                  <br />
                   <H3>Prazo de Correção</H3>
                 {/*  <P>
                    A correção da inscrição fica disponível após efetuar a inscrição.
                  </P> */}
                  <P>
                    Atenção! 
                    <br /> 
                    A correção das inscrições ficará disponível até  {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após o prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <br /> 
                  <H3>Checagem</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será logo após o término das correções , em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves} .
                  </P>
                  <br />
                  <H3>Inscrição de Absoluto</H3>
                  <P>
                    Somente atletas inscritos na categoria poderão se increver e participar
                    do absoluto.
                  </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a categoria da
                    sua inscrição no torneio. Exceção apenas para os master que poderá se
                    inscrever como absoluto adulto.
                  </P>
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

               {/*  <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>
                    As inscrições serão em divididas em três lotes:
                  </Span>
                  <H3>Primeiro Lote até {dataDeEncerramentoInscricaoLote1}</H3>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote1} </P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} </P>
                  <br />
                  <H3>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</H3>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote2} </P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} </P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote2ComboGieAbsoluto} </P>

                  <br />
                  <H3>Terceiro Lote até {dataDeEncerramentoInscricaoLote3}</H3>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote3} </P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsolutoLote3} </P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote3ComboGieAbsoluto} </P>
                  <br />
                  <br />


                </Collapse> */}
                <Collapse title="PAGAMENTO">
                  <H3>
                   2KG de alimentos não perecíveis , deverá ser entregue no momento da pesagem.
                  </H3>
                {/*   <H3>
                    É necessário completar todas as etapas até finalizar a operação de pagamento.
                  </H3> */}
                  {/* <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                  <p />
                  {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                </Collapse>

               {/*  <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                    inscrição, sendo obrigatório a comprovação e apresentação de atestado
                    médico.
                  </H3>
                  <H3>
                    Após o fim do período de inscrição não será possível o reembolso das
                    inscrições pagas.
                  </H3>
                </Collapse> */}

                <Collapse title="REGRAS">

                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                    Os atletas devem chegar 1 hora antes do início de suas respectivas categorias, pois o evento pode antecipar , e o W.O
                    será autorizado se o atleta não estiver presente.
                  </Span>
                  <Span>
                    Para as categorias com 3 lutadores, será aplicada a regra da CBJJ.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span>
                  <Span>
                    Medalhas para 1º,2º e somente um 3º lugar (semi-finalista que perdeu para o campeão da categoria).
                  </Span>
                 {/*  <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho no sorteio da chave estará automaticamente na final.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span> */}
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto ou qualquer carteirinha de alguma federação no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados e não poderão lutar o
                    Absoluto.
                  </Span>
                  <Span>
                    Afim de evitar chaves sem lutas o esquema de faixa usado
                    será o seguinte:
                  </Span>
                  <P> Branca; </P>
                  <P> Cinza, Amarela , Laranja e Verde(juntas) - classificados como Graduados ; </P>
                  <P> Azul; </P>
                  <P> Roxa; </P>
                  <P> Marrom; </P>
                  <P> Preta. </P>
                  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                    ele lutará como Juvenil faixa Azul.
                  </Span>

                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
                  <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span>
                  {/* <Span>Teremos 4 (quatro) aréas de lutas</Span> */}
                  {/*  <Span>A Arbitragem será composta pela Equipe da Federação de Arbítrio do Amazonas</Span> */}
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio.
                  </Span>
                  <br />
                  <H3>Pontuação por equipe</H3>
                  <H5>Categoria e Absoluto, todas as faixas</H5>
                  <P>1° lugar: 10 pontos</P>
                  <P>2° lugar: 5 pontos</P>
                  <P>3° lugar: 3 pontos</P>


                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as faixas.
                  </P>
                  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistência do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    CHAVES contendo apenas atletas da mesma equipe = PONTUA.
                  </P>
                  <P>
                    Em caso de empate, seguiremos a sequência:
                  </P>
                  <ul>
                    <li>
                      Quantidade de Ouro
                    </li>
                    <li>
                      Quantidade de Prata
                    </li>
                    <li>
                      Quantidade de Bronze
                    </li>
                    <li>
                      Sorteio
                    </li>
                  </ul>
                 {/*  <P>
                    Categorias com atletas somente da mesma academia não contam pontos
                    para a disputa por academias, para contar pontos é necessário ao menos um
                    atleta de outra academia para validar a chave.
                  </P> */}
                  <br />
                  <H3>Para o absoluto:</H3>
                  <P>
                    Não será permitido luta combinada.
                  </P>
                  <P>
                    Não será permitido fechamento dos finalistas.
                  </P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima ,  a organização fica sem a obrigação de fazer a entrega  da premiação  citado nesse edital.
                  </P>
                  <br />
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
                
                  

                  <Container>
                  
                  <span>
                      I COPA FAIXA SOLIDÁRIA DE JIU JITSU 2025
                  </span>
                  <br />
                  <span>
                    Data: 20/DEZ/2025
                  </span>
                  <br />
                  <span>
                    Local: Ginásio Arena Amadeu Teixeira
                  </span>
                  <br />
                  <br />
                  <h5>09:00 horas - categoria PRÉ MIRIM e MIRIM - 04/05 e 06/07 anos (Branca e Graduado) masculino e feminino.</h5>
                  <h5>09:30 horas - INFANTIL - 08/09 anos (Branca e Graduado) masculino e feminino.</h5>
                  <h5>10:00 horas - INFANTIL - 10/11 anos (Branca e Graduado) masculino e feminino.</h5>
                  <h5>10:30 horas - INFANTO-JUVENIL A - 12/13 anos (Branca e Graduado) masculino e feminino.</h5>
                  <h5>11:00 horas - INFANTO-JUVENIL - 14/15 anos (Branca e Graduado) masculino e feminino.</h5>
                  <h5>12:00 horas - JUVENIL - 16/17 anos (Branca e Graduado) masculino e feminino.</h5>
                  <h5>13:00 horas - Faixa Branca (Adulto/Máster/Sênior) masculino e feminino.</h5>
                  <h5>14:00 horas - Faixa PRETA (Adulto/Máster/Sênior) masculino e feminino.</h5>
                  <h5>15:00 horas - Faixa Marrom (Adulto/Máster/Sênior) masculino e feminino.</h5>
                  <h5>16:00 horas - Faixa Roxa (Adulto/Máster/Sênior) masculino e feminino.</h5>
                  <h5>17:00 horas - Faixa Azul (Adulto/Máster/Sênior) masculino e feminino.</h5>
                  <h5>18:00 horas - ABSOLUTOS.</h5>

                    <p><strong>Informações importantes:</strong></p> 
                    <ul>
                      {/* <li>As inscrições do Absoluto deverão ser feitas após o término das categorias.</li>
                      <li>Os absolutos serão disputados após o término das suas respectivas categorias.</li> */}
                      <li>O Atleta só poderá lutar diante da confirmação de sua inscrição com sua entrega dos alimentos não perecíveis.</li>
                       <li>O cronograma pode ser adiantado em até 1 hora, e atrasar conforme a necessidade do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 1 hora antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li> 
                     {/*  <li>Todos os atletas devem estar 45 minutos antes do tempo de sua categoria na área de aquecimento, podendo lutar até 30 minutos antes do horário previsto no cronograma.</li> */}
                       <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li> 
                    </ul>
                     <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss  
                  </Container>
                </Collapse>
                <Collapse title="CONTATO">
              {/*     <P>Caso Precise falar com o responsável do evento, entre em contato por telefone ou WhatsApp.</P>
                  <a target={"blank"} href="https://whatsa.me/5592992470538/?t=Ol%C3%A1,%20Juliana!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*1º%20COPA%20FAIXA%20SOLIDÁRIA%20DE%20JIU%20JITSU%202025*"
                   >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <br /> */}
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*I%20COPA%20FAIXA%20SOLIDÁRIA%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
               <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage()}>
                Inscrição
              </TournamentEnrollmentLinkEndpage> 

               <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                Correção da Inscrição
              </TournamentEnrollmentLinkEndpage> 
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

               <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem
              </TournamentLink> 

              {/* <TournamentLink
                // target="_blank"
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink> */}

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              <TournamentLink
                // target="_blank"
                href={rotaChavesGI}
              >
                Chaves
              </TournamentLink>

              <TournamentLink
                onClick={() => {
                  setResultadoModalOpen(true);
                  loadResultadoAcademias();
                }}
              >
                <span style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
                  <EmojiEventsIcon fontSize="small" />
                  Resultado das Academias
                </span>
              </TournamentLink>

              <TournamentLink
                onClick={() => {
                  setResultadoIndModalOpen(true);
                  loadResultadoIndividual();
                }}
              >
                <span style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
                  <PersonSearchIcon fontSize="small" />
                  Resultados Individuais
                </span>
              </TournamentLink>


              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Dialog
        open={resultadoModalOpen}
        onClose={() => setResultadoModalOpen(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", p: 2 }}>
          <DialogTitle sx={{ p: 0, fontWeight: "bold" }}>
            Resultado das Academias
          </DialogTitle>
          <IconButton onClick={() => setResultadoModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <TextField
          fullWidth
          placeholder="Pesquisar por academia, pontos, ouro/prata/bronze..."
          value={searchResultado}
          onChange={(e) => setSearchResultado(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          size="small"
          sx={{ px: 2, pb: 1 }}
        />

        <DialogContent sx={{ p: 2 }}>
          <table border={1} cellPadding={6} style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead style={{ backgroundColor: "#f5f5f5" }}>
              <tr>
                {resultadoRows[0] &&
                  Object.keys(resultadoRows[0]).map((k) => <th key={k}>{k}</th>)}
              </tr>
            </thead>
            <tbody>
              {filteredResultadoRows.map((row, i) => (
                <tr key={i}>
                  {Object.values(row).map((v: any, j: number) => (
                    <td key={j}>{String(v ?? "")}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </DialogContent>
      </Dialog>

      <Dialog
        open={resultadoIndModalOpen}
        onClose={() => setResultadoIndModalOpen(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", p: 2 }}>
          <DialogTitle sx={{ p: 0, fontWeight: "bold" }}>
            Resultados Individuais
          </DialogTitle>
          <IconButton onClick={() => setResultadoIndModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <TextField
          fullWidth
          placeholder="Pesquisar por atleta, academia, categoria..."
          value={searchResultadoInd}
          onChange={(e) => setSearchResultadoInd(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          size="small"
          sx={{ px: 2, pb: 1 }}
        />

        <DialogContent sx={{ p: 2 }}>
          <table border={1} cellPadding={6} style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead style={{ backgroundColor: "#f5f5f5" }}>
              <tr>
                {processedIndividual.keys.map((k) => (
                  <th key={k}>{k}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {processedIndividual.rows.map((row, i) => (
                <tr key={i}>
                  {processedIndividual.keys.map((k, j) => {
                    const isOrderCol = processedIndividual.keyOrder && k === processedIndividual.keyOrder;
                    const isCategoryCol =
                      processedIndividual.keyCategory && k === processedIndividual.keyCategory;

                    if (isOrderCol || isCategoryCol) {
                      if (!row.__mergeFirst) return null;
                      return (
                        <td key={j} rowSpan={row.__mergeSpan}>
                          {String(row?.[k] ?? "")}
                        </td>
                      );
                    }

                    return <td key={j}>{String(row?.[k] ?? "")}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </DialogContent>
      </Dialog>
      <Footer />
    </>
  );
};

export default ICopaFaixaSolidariaDeJiuJitsu2025;
